/* eslint-disable react/prop-types */
import React from 'react';
import ReactDraggableList from 'react-draggable-list';
import {draggableListItemFactory} from './components/draggable-list-item';

class DraggableList extends React.Component {
  render() {
    const props = {
      ...this.props,
      template: draggableListItemFactory(this.props.template),
    };
    return <ReactDraggableList {...props} />;
  }
}

export default DraggableList;
